// useRef code added in many lines to hide key board - 02-08-2024 -Dev Srini
import React, { useState, useEffect, forwardRef  } from 'react';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import RupeeTextField from '../common/RupeeTextfield';
import styles from './AddFunds.module.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import RecentWithdrawalsListController from './RecentWithdrawalsListController';
import { useNavigate } from 'react-router-dom';
import { display, styled } from '@mui/system';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import {
  Typography,
  Container,
  TextField,
  Pagination,
  ListItem,
  Button,
  Autocomplete,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  useMediaQuery,
  Radio,
  Modal,
  Toolbar,
  TablePagination,
  List,
  ListItemText,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Alert,
  TableBody,
  FormHelperText
} from '@mui/material';
import { Box, } from '@mui/system';
import successIcon from '../../assets/svg/success.svg'
import errorIcon from '../../assets/svg/error.svg'
import { capitalise } from '../../utilities/capitalise';
import MyLodder from '../lodder';
// removed bowser library related code in this file - 26-07-24 - Dev Srini
const AddFunds = forwardRef(({
  userInfo,
  userBanks,
  selectedBank,
  paymentMode,
  paymentSuccess,
  paymentOrderId,
  paymentTxId,
  paymentAmount,
  paymentData,
  paymentErrorMessage,
  handleRetry,
  handlePaymentSuccess,
  handlePaymentModeChange,
  handleBankChange,
  handleAmountValueChange,
  handleAddFundsSubmit,
  paymentList,
  showlodder,
  errmsg,
  errtype,
  upiPaymentfail,
  handleUpiPaymentFail,
  inputRef
}, ref) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const screen900px = useMediaQuery("(max-width : 900px)")
  const screen640px = useMediaQuery("(max-width : 640px)")
  const navigate = useNavigate();
  const [paymentSuccess1, SetpaymentSuccess] = useState(true)
  const [page, setPage] = useState(0);
  const [mpage, setMPage] = useState(1);
  const [mdata, setMdata] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(10);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const columns = [
    { id: 'transactionDate', label: 'Date' },
    { id: 'orderId', label: 'Order ID' },
    { id: 'bankRefNo', label: 'Bank Ref No' },
    { id: 'bankAccountNo', label: "Account No" },
    { id: 'amount', label: 'Amount' },
    { id: 'paymentMode', label: 'Mode' },
    { id: 'orderStatus', label: 'Status' },
    {id: 'failureMessage', label: 'Message'} // Srini - 19/11/24
  ];

    const convertUTCToIST = (utcString) => {
     return dayjs.utc(utcString).tz("Asia/Kolkata").format("DD/MM/YYYY HH:mm:ss");
    };



  const customScrollbarStyles = {
    background: "#000000",
    width: "100%",
    scrollbarWidth: "thin",
    scrollbarColor: 'rgba(170,170,170,0.4) transparent',
  };
  // removed bowser code - 26-07-24 - Dev Srini
  useEffect(() => {
    const newArr = paymentList && paymentList.slice((mpage - 1) * 5, (mpage) * 5)

    setMdata(newArr)
  }, [mpage, paymentList])
  const handleMPageChange = (event, newpage) => {
    setMPage(newpage);
  }
  const handleClose = () => {

    SetpaymentSuccess(false)
    handleUpiPaymentFail()
  }
  const handlePageChange = (event, newpage) => {
    setPage(newpage);
  }
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }
  // removed razorpay height adjustment in mobile view -30-07-24 - Dev Srini

  return (
    <Container maxWidth="lg" sx={{ marginTop: !isSmallScreen && "10px", background: isSmallScreen && "#1B2636", minHeight: "100vh" }} >
      {/* Changed to onTouch event - 23-07-24 - Dev Srini */}
      {isSmallScreen &&
        <Button onTouchStart={() => navigate("/dashboard")} sx={{ color: "#F3D45E", backgroundColor: "transparent", marginLeft: "10px", fontSize: "20px" }} ><ArrowBackIosIcon fontSize='10px' />Back</Button>
      }
      {/* Font size changed to 20px - 29-07-24 - Dev Srini */}
      <Toolbar className={styles.toolbar}>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, marginLeft: isSmallScreen ? "0px" : "-40px", display: "flex", justifyContent: "start"}}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="30" viewBox="0 0 24 24" fill="none">
            <path d="M16 12H18V16H16V12Z" fill="white" />
            <path d="M20 7V5C20 3.897 19.103 3 18 3H5C3.346 3 2 4.346 2 6V18C2 20.201 3.794 21 5 21H20C21.103 21 22 20.103 22 19V9C22 7.897 21.103 7 20 7ZM5 5H18V7H5C4.74252 6.98848 4.49941 6.87809 4.32128 6.69182C4.14315 6.50554 4.04373 6.25774 4.04373 6C4.04373 5.74226 4.14315 5.49446 4.32128 5.30818C4.49941 5.12191 4.74252 5.01152 5 5ZM20 19H5.012C4.55 18.988 4 18.805 4 18V8.815C4.314 8.928 4.647 9 5 9H20V19Z" fill="white" />
          </svg>
          &nbsp;&nbsp;Add Funds
        </Typography>
        {!isSmallScreen &&
          <Button onClick={() => navigate("/dashboard")} variant='text' sx={{
            color: "#F3D45E", backgroundColor: "transparent", marginRight: "-30px", '&:hover': {
              backgroundColor: 'transparent',
            }
          }}  ><ArrowBackIosIcon fontSize='10px' />Back</Button>}
      </Toolbar>
      {
        isSmallScreen ?
          <>
            <Grid container spacing={2} justifyContent={"start"}>
              {/* Font size changed to 20px - 29-07-24 - Dev Srini */}
              <Grid xs>
                <Box sx={{ margin: "5px 0px 0px 18px" }} >
                  <Typography sx={{ marginBottom: "10px", lineHeight: "1.2 !important", fontSize : "16px" }}>
                    {userInfo && capitalise(userInfo.CLIENT_NAME)}
                  </Typography>
                  <Typography variant="h7">
                    Client Code : {userInfo && userInfo.CLIENT_ID}
                  </Typography>
                </Box>
              </Grid>

              <Grid container rowSpacing={1} xs={12} sx={{ margin: "10px 0px 0px 20px" }}>
                <Box sx={{ width: '100%' }}>
                  <FormControl>
                    <FormLabel sx={{ fontSize: "20px", color: "#FFFFFF" }}>Payment Mode</FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={paymentMode}
                      onChange={handlePaymentModeChange}
                      row
                    >
                      <FormControlLabel value="upi" control={<Radio />} label="UPI" />
                      <FormControlLabel value="netbanking" control={<Radio />} label="Net banking" />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>

              <Grid container columnSpacing={0} xs sx={{ margin: "10px 10px 0px 15px" }}>
                <Autocomplete
                  disablePortal
                  size='small'
                  // id="combo-box-demo"
                  // options={userBanks}
                  options={userBanks || []}
                  value={selectedBank}
                  onChange={handleBankChange}
                  getOptionLabel={(option) => paymentMode === "upi" ? (`${option.Bank_Name} - ${option.UPIBANKID || 'No Upi Id'}`) : (`${option.Bank_Name} - ${option.Bank_AcNo}`)}
                  sx={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#241E41",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" }
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Bank Account" />}
                />
                {errtype === 1 &&
                  <FormHelperText className={styles.errtxt} id="component-error-text">{errmsg}</FormHelperText>
                }
              </Grid>
              
              <Grid container xs={12} sx={{ paddingTop: "0px" }}>
                <Grid xs={6}>
                  <RupeeTextField ref={ref} handleAmountValueChange={handleAmountValueChange} />
                  
                </Grid>
                <Grid
                  xs={6}
                  sx={{
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }} >
                  <Button
                    fullWidth
                    sx={{
                      fontWeight: "bold",
                      height: "40px",
                      marginLeft: "10px",
                      marginRight: "10px"
                    }}
                    // Changed to onTouch event - 23-07-24 - Dev Srini
                    onTouchStart={handleAddFundsSubmit}
                    variant="contained">Submit</Button>
                </Grid>
                {errtype === 2 &&
                    <FormHelperText className={styles.errtxt} id="component-error-text">
                      <span style={{ marginLeft: "35px" }}>{errmsg}</span>
                    </FormHelperText>}
              </Grid>

              <Typography variant="h6" sx={{ margin: "20px 0px 0px 35px",  }}>
                Recent Transactions
              </Typography>
              {/* removed bowser library code - 26-07-24 -Dev Srini */}
              {paymentList.length == 0 ? (
                <Grid style={{ display: 'flex', justifyContent: 'center' }}>
                  <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
                </Grid>
              ) : (<List sx={{ width: "100%", margin: "20px 10px 0px 30px", background: "#0B1420", borderRadius: "10px" }}>
                {mdata.map((item, index) => {
                  return (
                    <ListItem 
                    key={index}
                    className={styles.listItem} 
                    sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "1.5px solid #000000" }}
                  >
                      <ListItemText
                        sx={{ width: "100%" }}
                        primary={
                          <Box display="flex" >
                            <Grid width="35%" padding="0px">
                              <Typography className={styles.listPrimaryText}>Date</Typography>
                            </Grid>
                            <Grid width="35%" padding="0px">
                              <Typography className={styles.listPrimaryText} >Amount</Typography>
                            </Grid>
                            <Grid width="30%" padding="0px">
                              <Typography className={styles.listPrimaryText}>Mode</Typography>
                            </Grid>
                          </Box>
                        }
                        secondary={
                          <Box display="flex">
                            <Grid width="35%" padding="0px">
                              <Typography marginRight="15px" className={styles.listSecondaryText}>
                               {convertUTCToIST(item.transactionDate)}
                              </Typography>
                            </Grid>
                            <Grid width="35%" padding="0px" >
                              <Typography className={styles.listSecondaryText} >
                                ₹ {item.amount}
                              </Typography>
                            </Grid>
                            <Grid width="30%" padding="0px" >
                              <Typography className={styles.listSecondaryText}>{item.paymentMode}</Typography>
                            </Grid>
                          </Box>
                        }
                      />
                      <ListItemText
                        sx={{ width: "100%" }}
                        primary={
                          <Box display="flex" >
                            <Grid width="35%" padding="0px">
                              <Typography className={styles.listPrimaryText}>Account No.</Typography>
                            </Grid>
                            <Grid width="35%" padding="0px" >
                              <Typography className={styles.listPrimaryText} >Bank Ref No</Typography>
                            </Grid>
                          {/* Status removed - Srini - 19/11/24 */}
                          </Box>
                        }
                        secondary={
                          <Box display="flex">
                            <Grid width="35%" padding="0px">
                              <Typography marginRight="15px" className={styles.listSecondaryText} >
                                <span className={styles.x}>{"x".repeat(item.bankAccountNo.length - 4)}</span>{item.bankAccountNo.slice(-4)}
                              </Typography>
                            </Grid>
                            <Grid width="35%" padding="0px" >
                              <Typography className={styles.listSecondaryText} sx={{ wordWrap: "break-word", width: "85%" }} >
                                {item.bankRefNo}
                              </Typography>
                            </Grid>
                          </Box>
                        }
                      />
                      {/* New row added - Srini - 19/11/24 */}
                      <ListItemText
                        sx={{ width: "100%" }}
                        primary={
                          <Box display="flex" >
                            <Grid width="35%" padding="0px" >
                              <Typography className={styles.listPrimaryText}>Status</Typography>
                            </Grid>
                            <Grid width="65%" padding="0px">
                              <Typography className={styles.listPrimaryText}>Message</Typography>
                            </Grid>
                          </Box>
                        }
                        secondary={
                          <Box display="flex">
                            <Grid width="30%" padding="0px" mt='5px'>
                              {item.orderStatus === "1" ? (
                                <div className={styles.succdiv}>
                                  <Typography className={styles.succ} >Success</Typography>
                                </div>
                              ) : (
                                <div className={styles.faildiv}>
                                  <Typography className={styles.fail} >Failed</Typography>
                                </div>
                              )}
                            </Grid>
                            {/* Srini - 19/11/24 */}
                            <Grid width='70%' ml='20px' padding="0px" >
                              <Typography sx={{color: '#fff', fontSize: '10px', fontWeight: 400}}>{item.failureMessage}</Typography>
                            </Grid>

                          </Box>
                        }
                      />
                    </ListItem>
                  )
                })}
                <Grid sx={{ display: "flex", justifyContent: "center", padding: "10px 0px 10px 0px" }}>
                  <Pagination showFirstButton showLastButton count={Math.ceil(paymentList.length / 5)} size="small" page={mpage}
                    onChange={handleMPageChange} />
                </Grid>
              </List>)}
            </Grid>
          </> :
          <Grid container spacing={2} minHeight={160}>
            <Grid xs={screen900px ? 6 : 3} sx={{ paddingLeft: "0px" }} display="flex" justifyContent="left" alignItems="start" >
              <Box sx={{ width: '100%' }}>
                <Typography sx={{ fontSize: "20px", marginBottom: "12px" }}>
                  {userInfo && capitalise(userInfo.CLIENT_NAME)}
                </Typography>
                <Typography variant="h7">
                  Client Code : {userInfo && userInfo.CLIENT_ID}
                </Typography>
              </Box>
            </Grid>
            <Grid xs={screen900px ? 6 : 4} display="flex" justifyContent="center" alignItems="start" >
              <Box sx={{ width: '100%', marginLeft: "10px" }}>
                <FormControl>
                  <FormLabel sx={{
                    fontSize: "20px",
                    color: "#FFFFFF"
                  }} >Payment Mode</FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={paymentMode}
                    name="radio-buttons-group"
                    onChange={handlePaymentModeChange}
                    row
                  >
                    <FormControlLabel value="upi" control={<Radio />} label="UPI" />
                    <FormControlLabel value="netbanking" sx={{ marginLeft: screen640px ? "-11px" : "0px" }} control={<Radio />} label="Net banking" />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Grid>
            <Grid xs={screen900px ? 12 : 5} paddingLeft={0} container spacing={2} alignItems="center" marginTop={screen900px ? "-10px" : "-30px"} >
              <Grid xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={userBanks || []}
                  value={selectedBank}
                  onChange={handleBankChange}
                  getOptionLabel={(option) => paymentMode === "upi" ? (`${option.Bank_Name} - ${option.UPIBANKID || 'No Upi Id'}`) : (`${option.Bank_Name} - ${option.Bank_AcNo}`)}
                  fullWidth
                  size='small'
                  sx={{
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#131E2E",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    },
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Bank Account" />}
                />
                {errtype === 1 &&
                  <FormHelperText className={styles.errtxt} id="component-error-text">{errmsg}</FormHelperText>
                }
              </Grid>
              <Grid xs={8} sx={{ paddingTop: "0px" }}>
                <RupeeTextField
                  handleAmountValueChange={handleAmountValueChange}
                />
                
              </Grid>
              <Grid xs={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: "10px", paddingTop: "0px" }}>
                <Button
                  variant="contained"
                  size="medium"
                  sx={{
                    fontWeight: "bold",
                    width: screen900px ? "100%" : "150px",
                    height: "40px"
                  }}
                  onClick={handleAddFundsSubmit}
                  fullWidth>Submit</Button>
              </Grid>
              {errtype === 2 &&
                  <FormHelperText className={styles.errtxt} id="component-error-text" sx={{marginLeft : "20px"}}>{errmsg}</FormHelperText>}
            </Grid>
            <Typography variant="h5" sx={{ marginTop: "30px" }} gutterBottom>
              Recent Transactions
            </Typography>
            <TableContainer component={Paper} className={styles.tablecontainer} sx={customScrollbarStyles} >
              {paymentList == 0 ? (<Table>
                <TableRow style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                  <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
                </TableRow>
              </Table>) :
                (<Table sx={{ width: "100%", background: "#0B1420", marginTop: "20px", borderRadius: "10px" }}>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell className={styles.tablecellheader} sx={{ borderBottom: "2px solid #000000" }} key={column.id}>{column.label}</TableCell>
                      ))}
                      <TableCell className={styles.tablecellheader} style={{ display: 'none' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paymentList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                      <TableRow key={index}>
                        {columns.map((column) => (
                          <TableCell
                            sx={{ borderBottom: "2px solid #000000", 
                              width: column.id === 'failureMessage' ? '225px' : 'auto',
                            }} // Srini - 19/11/24
                            className={`${styles.tablecell} ${column.id === 'Status' && styles.tablecelllow}`}
                            key={column.id}
                          >
                            {column.id === 'orderStatus' ?
                              row[column.id] === '1' ?
                                <div className={styles.succdiv}>
                                  <Typography className={styles.succ}>
                                    Successful
                                  </Typography>
                                </div>
                                :
                                <div className={styles.faildiv}>
                                  <Typography className={styles.fail}>
                                    Failed
                                  </Typography>
                                </div>
                              :

                              (
                                column.id === 'amount' ?
                                  <Typography className={styles.tabletxt} 
                                  // Srini - 19/11/24
                                  sx={{ fontSize: column.id === 'failureMessage' ? '10px' : '12px'}}>
                                    ₹  {row[column.id]}
                                  </Typography>

                                  :
                                  
                                  <Typography className={styles.tabletxt} sx={{ fontSize: column.id === 'failureMessage' ? '10px' : '12px'}}>
                                    {/* Date format - Srini - 19/11/24 */}
                                    {column.id === "transactionDate" ? (
                                      typeof row[column.id] === "string" ? (
                                        <>
                                           {convertUTCToIST(row.transactionDate)}
                                        </>
                                      ) : null
                                    ) : (
                                      row[column.id]
                                    )}
                                  </Typography>
                              )}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>)}
            </TableContainer>
            {paymentList.length > 0 && <TablePagination
              sx={{ background: "#0B1420", width: "100%" }}
              rowsPerPageOptions={[10, 20, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={paymentList.length}
              component="div"
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />}
          </Grid>
      }

      {/* Payment Success Modal */}
      <Modal
        open={paymentSuccess && paymentSuccess1}
        disableBackdropClick={false}
        onClose={() => handleClose()}
        sx={{ border: 'none' }}>
        <Box

          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isSmallScreen ? '90%' : '50%',
            height: 'auto',

            outline: 'none',
            background: '#ffffff',
            p: 4,
            borderRadius: '8px',
            padding: '2%',
            justifyContent: 'center', alignItems: 'center',
            "@media only screen and (max-device-width: 480px)": {
              width: '90%',


            }
          }}
        >
          <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <img src={successIcon} alt={successIcon} width='80'></img>
          </Grid>
          <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
            <Typography className={styles.payment_succ}>Payment Successful</Typography>
            <Typography className={styles.payment_msg}>Order No: {paymentOrderId}</Typography>
            <Typography className={styles.payment_msg}>Transaction No: {paymentTxId}</Typography>
            <Grid style={{ width: '100%', borderBottom: '1px solid #D9D9D9' }}></Grid>
            <Typography className={styles.payment_msg}>Amount: ₹ {paymentAmount}</Typography>

          </Grid>
        </Box>
      </Modal>

      {/* Payment Failure Modal */}
      <Modal
        open={!paymentSuccess && paymentSuccess1 && paymentData && paymentData.status === 'Failure'}
        disableBackdropClick={false}
        onClose={() => handleClose()}

        sx={{ border: 'none' }}>
        <Box

          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isSmallScreen ? '90%' : '50%',
            height: 'auto',

            outline: 'none',
            background: '#ffffff',
            p: 4,
            borderRadius: '8px',
            padding: '2%',
            justifyContent: 'center', alignItems: 'center',
            "@media only screen and (max-device-width: 480px)": {
              width: '90%',


            }
          }}
        >
          <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <img src={errorIcon} alt="errorIcon" width='70'></img>
          </Grid>
          <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
            <Typography className={styles.payment_succ} >Payment Failed</Typography>
            {paymentErrorMessage && <Typography className={styles.payment_msg}>Message: {paymentErrorMessage}</Typography>}
            {paymentOrderId && <Typography className={styles.payment_msg}>Order No: {paymentOrderId}</Typography>}
            {paymentTxId && <Typography className={styles.payment_msg1}>Remark: {paymentTxId}</Typography>}
            <Grid style={{ width: '100%', borderBottom: '1px solid #D9D9D9' }}></Grid>
            {paymentAmount && <Typography className={styles.payment_msg}>Amount: ₹ {paymentAmount}</Typography>}

          </Grid>
        </Box>
      </Modal>
      
      <Modal
        open={!paymentSuccess && upiPaymentfail}
        disableBackdropClick={false}
        onClose={() => handleClose()}

        sx={{ border: 'none' }}>
        <Box

          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isSmallScreen ? '90%' : '50%',
            height: 'auto',

            outline: 'none',
            background: '#ffffff',
            p: 4,
            borderRadius: '8px',
            padding: '2%',
            justifyContent: 'center', alignItems: 'center',
            "@media only screen and (max-device-width: 480px)": {
              width: '90%',


            }
          }}
        >
          <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <img src={errorIcon} alt="errorIcon" width='70'></img>
          </Grid>
          <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
            <Typography className={styles.payment_succ} >Payment Failed</Typography>
            {paymentErrorMessage && <Typography className={styles.payment_msg}>Message: {paymentErrorMessage}</Typography>}
            {paymentOrderId && <Typography className={styles.payment_msg}>Order No: {paymentOrderId}</Typography>}
            {paymentTxId && <Typography className={styles.payment_msg1}>Transaction No: {paymentTxId}</Typography>}
          </Grid>
        </Box>
      </Modal>
      <MyLodder canShow={showlodder} />
    </Container>
  );
});
export default AddFunds;
